(function (window, angular, undefined) {
var app = angular.module('formApp');

app.filter('titleCase', function() {
return function(input) {
input = input || '';
return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};
});

app.directive('typeahead', ['$timeout', '$anchorScroll', 'scrollToPoint','$rootScope', function ($timeout, $anchorScroll, scrollToPoint, $rootScope) {
return {
restrict: 'EA',
require: "ngModel",
link: function ($scope, element, attrs, model) {

var dataSrc = $scope.$eval(attrs.datasource);
var exclSrc = $scope.$eval(attrs.exclusions);
var bannedSrc = $scope.$eval(attrs.banned);
var thisListBox = element.next(".typeaheadList")[0];

$scope.searchItems = dataSrc;
//Sort Array
$scope.searchItems.sort();
//Define Suggestions List
$scope.suggestions = [];
//Define Selected Suggestion Item
$scope.selectedIndex = -1;

$scope.setSelectionState = function (v) {
$scope.setSelectionStateMouse = v;
};

element.bind('blur', function (e) {
if ($scope.setSelectionStateMouse == null) {
$timeout(function () {
$scope.suggestions = [];
$scope.selectedIndex = -1;
});
}
});

$scope.loadAllValues = function () {
search();
};

//Function To Call On ng-change
$scope.search = function () {
search();
};

//Text Field Events
//Function To Call on ng-keydown
$scope.checkKeyDown = function (event) {
if (event.keyCode === 40) { //down key, increment selectedIndex
event.preventDefault();
if ($scope.selectedIndex < $scope.suggestions.length - 1) {
$scope.selectedIndex++;
} else {
$scope.selectedIndex = 0;
}
model.$setViewValue($scope.suggestions[$scope.selectedIndex][0]);
model.$render();
updateScroll();

} else if (event.keyCode === 38) { //up key, decrement selectedIndex
event.preventDefault();
if ($scope.selectedIndex > 0) {
$scope.selectedIndex--;
} else {
$scope.selectedIndex = $scope.suggestions.length - 1;
}
model.$setViewValue($scope.suggestions[$scope.selectedIndex][0]);
model.$render();
updateScroll();

} else if (event.keyCode === 13) { //enter key, empty suggestions array
if ($scope.suggestions.length > 0) {
event.preventDefault();
$scope.suggestions = [];
$scope.selectedIndex = -1;
// $scope.AssignValueAndHide($scope.selectedIndex); don't think we need this here
}

} else if (event.keyCode === 9) {
// On tab out empty the suggestions array          
$scope.suggestions = [];

} else if (event.keyCode === 27) { //ESC key, empty suggestions array
event.preventDefault();
$scope.suggestions = [];
$scope.selectedIndex = -1;
}
};

//Function To Call on ng-keyup
$scope.checkKeyUp = function (event) {
if (event.keyCode !== 40 && event.keyCode !== 38 && event.keyCode !== 27 && event.keyCode !== 13 && event.keyCode !== 9 ) {
$scope.search();
}
};
//List Item Events
//Function To Call on ng-click
$scope.AssignValueAndHide = function (index) {
console.log('assign');
if(index > -1) {
console.log('inside assign');
model.$setViewValue($scope.suggestions[index][0]);
model.$render();
delete $scope.setSelectionStateMouse;
$timeout(function () {
$scope.suggestions = [];
$scope.selectedIndex = -1;
});
}
};

function breedChecker(modelValue){
var validBreed = false;  
angular.forEach($scope.searchItems, function (value, key) {
if (value && modelValue && (value.toLowerCase() === modelValue.toLowerCase())) {
validBreed = true;
}
});
return validBreed;

}

// check if breed in breed list
model.$validators.isAValidBreed = function (modelValue) {
$scope.validBreed = false;     
angular.forEach($scope.searchItems, function (value, key) {
if(value && modelValue && (value.toLowerCase() === modelValue.toLowerCase())) {
$scope.validBreed = true;  
}       
});  
return $scope.validBreed;   
};

// check only if dog and special breed to show call us modal
$scope.onBlur = function(e) {
    // reset values 
    $scope.isSpecialBreed = false;
    $scope.isBannedBreed = false;
    checkSpecialistBreed(e);
    checkBannedBreed(e);
};

function checkSpecialistBreed(e) {
    if($scope.pet.type === 'dog') {
        var modelValue;
        // target the dog that is a specialist/banned breed
        var target = 'SPECIAL.BREED.' + e.target.id.toUpperCase();
        angular.forEach(exclSrc, function (value, key) {
        // need timeout as delay in getting value
        $timeout(function() {
        modelValue = e.target.value;
        if(value && modelValue && (value.toLowerCase() === modelValue.toLowerCase())) {
        // set isSpecialBreed to true to show modal
        $scope.isSpecialBreed = true;
        }
        if($scope.isSpecialBreed){
            $rootScope.$broadcast(target);
            // reset suggestions list
            $scope.suggestions = [];
            // clear the breed field
            $scope.pet.details.breedOne = '';
            } 
        }, 150);                   
        });    
    } 
}

function checkBannedBreed(e) {
    if($scope.pet.type === 'dog') {
        var modelValue;
        // target the dog that is a specialist/banned breed
        var target = 'SPECIAL.BREED.' + e.target.id.toUpperCase();
        angular.forEach(bannedSrc, function (value, key) {
        // need timeout as delay in getting value
        $timeout(function() {
        modelValue = e.target.value;
        if(value && modelValue && (value.toLowerCase() === modelValue.toLowerCase())) {
        // set isSpecialBreed to true to show modal
        $scope.isSpecialBreed = true;
        if(value && modelValue === 'American Bully XL' || value && modelValue === 'Pit Bull Terrier' || 
        value && modelValue === 'Japanese Tosa' || value && modelValue === 'Dogo Argentino' || 
        value && modelValue === 'Fila Braziliero') {
        $scope.isBannedBreed = true;
        } 
        }
        if($scope.isSpecialBreed){
            $rootScope.$broadcast(target);
            // reset suggestions list
            $scope.suggestions = [];
            // clear the breed field
            $scope.pet.details.breedOne = '';
            } 
        }, 150);                   
        });    
    } 
}

// dog only check if multi breed not duplicated
model.$validators.dupBreed = function (modelValue) {
if(attrs.multibreed === 'one' && modelValue === $scope.pet.details.breedTwo){
return false;
} 
else if (attrs.multibreed === 'two' && modelValue === $scope.pet.details.breedOne){
return false;
}
else{
return true;
}

};

model.$parsers.push(function (modelValue) {
var parsed = modelValue;
angular.forEach($scope.searchItems, function (value, key) {
if (value && modelValue && (value.toLowerCase() === modelValue.toLowerCase())) {
parsed = value;
}
});
return parsed;

});

$scope.setTouched = function(){
element.$setTouched();
};

function escapeRegexp(queryToEscape) {
return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
}

function multiBreedFilter (checkedBreed){
if ($scope.pet.type === 'dog' && $scope.pet.details.type === 'MultiBreed' && checkedBreed === $scope.pet.details.breedOne){
return false;
}
else if ($scope.pet.type === 'dog' && $scope.pet.details.type === 'MultiBreed' && checkedBreed === $scope.pet.details.breedTwo){
return false;
}

return true;

}

function search() {
var i;
var priority = [];
$scope.suggestions = [];
$scope.selectedIndex = -1;
if (model.$viewValue) {

var myMaxSuggestionListLength = 0;
var searchTextSmallLetters = model.$viewValue.toLowerCase();
for (i = 0; i < $scope.searchItems.length; i++) {
var searchItemsSmallLetters = $scope.searchItems[i].toLowerCase();

if (searchItemsSmallLetters.indexOf(searchTextSmallLetters) !== -1) {
var val = ('' + $scope.searchItems[i]).replace(new RegExp(escapeRegexp(model.$viewValue), 'gi'), '<strong>$&</strong>');
if(searchItemsSmallLetters.indexOf(searchTextSmallLetters) === 0) {
if(multiBreedFilter($scope.searchItems[i])){
    priority.push([$scope.searchItems[i], val]);  
}

} else {

$scope.suggestions.push([$scope.searchItems[i], val]);
}
myMaxSuggestionListLength += 1;
if (myMaxSuggestionListLength === 600) {
break;
}
}
}
$scope.suggestions = priority.concat($scope.suggestions);
} else {
console.log('else');
for (i = 0; i < $scope.searchItems.length; i++) {
if($scope.pet.details.type === 'MultiBreed' && $scope.pet.details.breedOne){
if($scope.searchItems[i] !== $scope.pet.details.breedOne){

$scope.suggestions.push([$scope.searchItems[i], $scope.searchItems[i]]); 
}
}
else if($scope.pet.details.type === 'MultiBreed' && $scope.pet.details.breedTwo){
if($scope.searchItems[i] !== $scope.pet.details.breedTwo){

    $scope.suggestions.push([$scope.searchItems[i], $scope.searchItems[i]]); 
    }
}    
else{
$scope.suggestions.push([$scope.searchItems[i], $scope.searchItems[i]]);  
}
}
}
// reset top of list
thisListBox.scrollTop = 0;                   
}

function updateScroll() {
var listItems = thisListBox.getElementsByTagName('li'),
height = listItems[0].offsetHeight,
top = height * $scope.selectedIndex,
bot = top + height,
hgt = thisListBox.clientHeight,
scrollTop = thisListBox.scrollTop;

if (top < scrollTop) {
thisListBox.scrollTop = top;
} else if (bot > scrollTop + hgt) {
thisListBox.scrollTop = bot - hgt;
}
}
}
};
}]);
})(window, window.angular);